import { Utils } from '@gv/triage-components';

import { generateUrl } from 'utils/helpers';
import { hospitalFeedbackPayload } from 'pages/cases/list/types';

import { URL } from '../constants';
import { apiInstance, apiLoaderInstance } from '../instance';

export const hospitalList = () => apiInstance.get(URL.GET_HOSPITAL_LIST);

export const getFeedBackList = (filters: any, limit: any, offset: any) =>
  apiInstance.get(
    Utils.Query.addParamsToUrl(URL.GET_CUSTOMER_FEEDBACK_LIST, {
      limit,
      offset,
      filters,
    })
  );

export const sendFeedbackForm = (
  caseId: any,
  feedbackEmail: String,
  callOutcomes: String
) => {
  return apiInstance.post(URL.SEND_TYPE_FORM, {
    callOutcomes,
    feedbackEmail,
    case_form_id: caseId,
  });
};

export const assignTypeForm = (typeformId: any, hospitalID: any) => {
  return apiInstance.post(URL.ASSIGN_TYPE_FORM, {
    type_form_id: typeformId,
    hospital_ids: hospitalID,
  });
};

export const endCallChatVideo = (channelName: string) => {
  return apiInstance.post(URL.END_VIDEO_CHAT, {
    channelName,
  });
};

export const checkTypeFormHospital = (hospitalId: any) =>
  apiInstance.get(`${URL.CHECK_ASSIGN_HOSPITAL}/${hospitalId}`);

export const exportReportData = (filters: any) =>
  apiInstance.get(
    Utils.Query.addParamsToUrl(URL.GET_EXPORT_REPORT, {
      filters,
    }),
    { responseType: 'blob' }
  );

export const hospitalFeedback = (values: hospitalFeedbackPayload) => {
  const {
    case_id,
    user_id,
    hospital_id,
    wow_experience,
    solved_problem,
    generated_growth,
    additional_comments,
    accurate_and_fast_service,
  } = values;
  return apiInstance.post(URL.HOSPITAL_FEEDBACK, {
    case_id,
    user_id,
    hospital_id,
    wow_experience,
    solved_problem,
    generated_growth,
    additional_comments,
    accurate_and_fast_service,
  });
};

export const getRatioOfCalls = (filters: any) => {
  return apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(URL.GET_RATIO_OF_CALLS, filters)
  );
};

export const getChatID = (id: string) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(
      generateUrl(URL.GET_GV_TALK_CONATCTS_BY_ID, { id })
    )
  );

export const getKanbanCheckin = ({
  limit,
  offset,
  search,
  end_date,
  start_date,
  hospital_id,
}: any) =>
  apiInstance.get(
    Utils.Query.addParamsToUrl(URL.GET_CHECKINS, {
      limit,
      search,
      offset,
      end_date,
      start_date,
      hospital_id,
    })
  );

export const putKanbanCheckin = ({ status_id, checkin_id }: any) =>
  apiInstance.put(URL.UPDATE_CHECKIN, {
    status_id,
    checkin_id,
  });
